
    import Vue from "vue";
    import "leaflet/dist/leaflet.css";
    import ApiButton from "@/components/ApiButton.vue";
    import BookingProfileModal from "@/views/Modals/BookingsModals/BookingProfileModal.vue"
    import Component from "vue-class-component";
    import { BookingVM } from "@/model/Api/VM/BookingVM";
    import { Prop } from "vue-property-decorator";
    import { required } from "vuelidate/lib/validators";
    import { Utils } from "@/utilities/Utils";
    import { Validations } from "vuelidate-property-decorators";
    import { IBookingProfile } from "@/model/BookingProfile";
    import { Watch } from "vue-property-decorator";
    import * as toastr from "toastr";
    import { LMap, LTileLayer, LMarker, LPopup, LIcon, LTooltip } from "vue2-leaflet";
    import L, { LatLng } from "leaflet";
    import BookingMapModal from "@/views/Modals/BookingsModals/BookingMapModal.vue";
    import { CostCode, ICostCode } from "@/model/CostCode";
    import { ApiClient } from "@/utilities/ApiClient";


    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

    @Component({
        components: {
            ApiButton,
            BookingProfileModal,
            BookingMapModal,
            DateRangePicker,
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            LIcon,
            LTooltip
        }
    })

    export default class DetailsTab extends Vue {

        mounted(){
            this.formatDateInput();
            if (this.booking.id != 0) {
                this.addMarker(this.booking.worksLatitude, this.booking.worksLongitude);
                this.center = new LatLng(this.booking.worksLatitude, this.booking.worksLongitude);
            }
            setTimeout(() => {
                this.isMapReady = true;
            }, 200);
        }

        //
        // -- properties
        //

        @Prop({}) private booking !: BookingVM;
        @Prop({}) private bookingProfiles !: Array<IBookingProfile>;
        @Prop({}) private locationValidation !: boolean;
        @Prop({}) private costCodes !: Array<CostCode>;
        @Prop({}) private rerenderMap !: number;
        private timeOptions: Array<string> = ["00:00", "00:30", "01:00", "01:30", "02:00", "02:30",
            "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30",
            "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30",
            "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
            "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30",
            "23:00", "23:30"];
        private minDate = new Date;
        private showTotalStays: boolean = true;

        // -- Watchers
        //
        
        @Watch("booking.worksLatitude")
        onLatitudeChange(value: any) {
                this.isMapReady = false;
                if (this.booking.worksLatitude == 0) {
                    return;
                }
                this.addMarker(this.booking.worksLatitude, this.booking.worksLongitude);
                this.center = new LatLng(this.booking.worksLatitude, this.booking.worksLongitude);
                // map does not fully render properly unless setTimeout 
                setTimeout(() => {
                    this.isMapReady = true;
                }, 200);
        }

        @Watch("rerenderMap")
        onRenderChange(value: any) {
            console.log("yooooooo", this.rerenderMap)
                this.isMapReady = false;
                if (this.booking.worksLatitude == 0) {
                    return;
                }
                this.addMarker(this.booking.worksLatitude, this.booking.worksLongitude);
                this.center = new LatLng(this.booking.worksLatitude, this.booking.worksLongitude);
                // map does not fully render properly unless setTimeout 
                setTimeout(() => {
                    this.isMapReady = true;
                }, 100);
        }

        // only watch the last stay to avoid watch firing twice and causing duplicate dates saves
        // @Watch("booking.lastCheckOut")
        // onLastStayChanged() {
        //    this.$emit("saveBookingDates");
        // }

        // computed property

        private get buttonDisabled(): boolean {
            if (Utils.isEmptyId(this.booking.guid)) return true;
            return false;
        }

        private get totalDays(): number {
            console.log(this.booking.guid)
            if (!Utils.hasDateValue(this.booking.firstStay)) {
                return 0;
            } 
            if (Utils.isEmptyId(this.booking.guid)) {
                var difference =  Math.floor((Date.parse(this.booking.lastStay.toString()) - Date.parse(this.booking.firstStay.toString())) / 86400000) + 1
                console.log(difference)
                return difference
            }
            else return this.booking.totalDays;
        }

        

        theme = {
            primary: '#17a2b8',
            secondary: '#2D3E50',
            ternary: '#93A0BD',
            border: '#e6e6e6',
            light: '#ffffff',
            dark: '#000000',
            hovers: {
                day: '#CCC',
                range: '#e6e6e6'
            }
        };
        panels = ['range'];
        presets = ['custom'];

        // map properties
        showMap: boolean = true;
        zoom: number = 0;
        max: number = 12;
        min: number = 12;
        center = new LatLng(52.18477393782657, -1.2647409088759765);
        url: string = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        mapOptions = {dragging: false, zoomControl: false };
        bounds: null = null;
        attribution: string = '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors';
        markers: any = [];
        isMapReady = false;

        //
        // -- methods
        //

        loadBooking() {
            this.$emit("loadBooking");
        }

        private get hasLatLng(): boolean {
            if (this.booking.latLng == "[, ]" || this.booking.latLng == "[0, 0]") {
                return false;
            }
            else {
                return true;
            }
        }

        private get totalNights(): number {
            let retVal = 0;
            if (this.bookingProfiles.length > 0) {
                for (const profile of this.bookingProfiles) {
                    retVal += +profile.noOfRooms
                }
            }
            return retVal;
        }

        manageBookingProfile() {           
            const dialogue = this.$refs.bookingProfileModal as BookingProfileModal & { show: () => void };
            dialogue.show(this.booking.isDisabled);
            return;
        }

        saveProfile() {
            this.$emit("saveProfile");
            return;
        }

        openMapModal() {
            if (this.booking.isDisabled) {
                toastr.warning("Contact admin to change");
                return;
            }
            const dialogue = this.$refs.bookingMapModal as BookingMapModal & { show: () => void };
            dialogue.show(this.booking.id);
        }

        updateLatLng(lat: number, lng: number, what3words: string, placeName: string) {
            this.booking.worksLatitude = lat;
            this.booking.worksLongitude = lng;
            this.booking.worksWhatThreeWords = what3words;
            this.booking.worksPlaceName = placeName; 
            this.center = new LatLng(lat, lng);
            this.addMarker(lat, lng);
        }

        addMarker(lat: number, lng: number) {
            this.markers = [];
            this.markers.push([lat, lng]);
        }

        async isDetailsValid(): Promise<boolean> {
            this.$v.$reset();
            this.$v.$touch();
            await this.waitForValidation();
            return Promise.resolve(!this.$v.$error);
        }

        // from https://github.com/vuelidate/vuelidate/issues/179
        private waitForValidation() {
            return new Promise<void>(resolve => {
                if (this.$v.$error || !this.$v.$pending) {
                    return resolve();
                }
                const poll = setInterval(() => {
                    if (!this.$v.$pending) {
                        clearInterval(poll)
                        resolve()
                    }
                }, 200);
            })
        }


        private currencyFormatter(value: string) {
            let num = +value;
            if (isNaN(num)) num = 0;
            //return num.toLocaleString(undefined, {maximumFractionDigits:2});
            return num.toFixed(2);
        }

        @Validations()
        validations() {
            const validations = {
                booking: {} as any
            };
            // validations.booking.worksPostCode = { required };
            validations.booking.firstStay = { required };
            validations.booking.lastCheckOut = { required };
            validations.booking.worksLatitude = { isNonZero: (value: number) => +value > 0 };
            validations.booking.contractorID = { isNonZero: (value: number) => +value > 0 };
            validations.booking.foodAllowance = { isNonZero: (value: number) => +value > 0 };
            validations.booking.description = { required };
            validations.booking.defaultNightsPerStay = { isNonZero: (value: number) => +value > 0  };
            validations.booking.latestArrivalDefault = { hasTime: (value: Date) => {
                if (!value) {
                    return false;
                }
                if (value.getMinutes() !== 0 && value.getMinutes() !== 30) {
                    return false;
                }
                if (value.getTime() === Utils.emptyDateValue) {
                    return false;
                }
                return true;
            }};
            return validations;
        }

        //datepicker input box
        checkInText: string = "";
        checkOutText: string = "";
   
        //sets the daterange for the highlighted dates
        dateRange = {
            startDate: this.booking.firstStay,
            endDate: this.booking.lastStay          
        }

        shortDate(date: Date){
            const retVal = 
            date.toLocaleDateString("en-uk", { weekday: 'short' }) +
                    " " +
                    date.getDate() +
                    " " +
                    date.toLocaleDateString("en-uk", { month: 'short' });
                    return retVal;
        }

        //sets the values on the input box when opening modal
        formatDateInput(){
            if (this.booking.isNew) {
                this.checkInText = "Select First Stay"
                this.checkOutText = "Select Last Stay"
            }
            if (!this.booking.isNew) {
                this.checkInText = this.shortDate(this.booking.firstStay)
                this.checkOutText = this.shortDate(this.booking.lastStay)
            }
        }

        //disables selection of dates before today
        // dateFormat(classes: any, date: any) {
        //     if (!classes.disabled) {
        //         classes.disabled = date.getTime() < this.booking.firstStay
        //     }
        //     return classes
        // }

        //first click
        startSelection(str: string, date: Date){
            this.booking.firstStay = date;
            this.checkInText = this.shortDate(date);
        }

        //second click
        finishSelection(str: string, date: Date){
            if(this.checkInText.toString() === "Select First Stay"){
                this.checkInText = "Select First Stay";
                this.checkOutText = "Select Last Stay";
                return;
            }
            if (date < this.booking.firstStay) {
                toastr.warning("End date cannot be less then the start date.");
                this.openCloseDateRangePicker();
                return;
            }
            this.booking.lastStay = date;
            this.checkOutText = this.shortDate(date);
            this.showTotalStays = true;
            this.$emit("saveBookingDates");
        }

        //events for when you click on the picker
        openCloseDateRangePicker(){
            const date = new Date();
            //this.dateFormat(this.dateRangePickerLocaleData, date)
            this.dateRange.startDate = date
            this.dateRange.endDate = date
            this.booking.firstStay = date
            this.booking.lastStay = date
            this.checkInText = "Select First Stay";
            this.checkOutText = "Select Last Stay";
        }

        //clicking on the date picker
        logEvent(str: string, event: Event){
            const date = new Date();
            if(event.toString() === 'true'){//datepicker is opened
                this.showTotalStays = false;
                //this.dateFormat(this.dateRangePickerLocaleData, date)
                this.dateRange.startDate = date
                this.dateRange.endDate = date
                this.booking.firstStay = date
                this.booking.lastStay = date
                this.checkInText = "Select First Stay";
                this.checkOutText = "Select Last Stay";
                return;
            }
            if(event.toString() === 'false'){//datepicker is closed
                if(this.checkInText.toString() === 'Select First Stay' && this.checkOutText.toString() === 'Select Last Stay'){
                    return;
                }
                if(this.checkInText.toString() === 'Select First Stay' && this.checkOutText.toString() !== 'Select Last Stay'){
                    this.dateRange.startDate = date
                    this.dateRange.endDate = date
                    this.booking.firstStay = date
                    this.booking.lastStay = date
                    this.checkInText = "Select First Stay";
                    this.checkOutText = "Select Last Stay";
                    return;
                }
                if(this.checkInText.toString() !== 'Select First Stay' && this.checkOutText.toString() === 'Select Last Stay'){
                    this.dateRange.startDate = date
                    this.dateRange.endDate = date
                    this.booking.firstStay = date
                    this.booking.lastStay = date
                    this.checkInText = "Select First Stay";
                    this.checkOutText = "Select Last Stay";
                    return;
                }
            }
        }

        copyWhat3Words() {
            navigator.clipboard.writeText(this.booking.w3w);
            toastr.info(`Copied ${this.booking.w3w}`);
        }

        //formating options
        dateRangePickerLocaleData = {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            weekLabel: 'W',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 1
        }
    }
